// extracted by mini-css-extract-plugin
export default {"labelContainer":"RadioLabel_labelContainer__i+07T","fieldText":"RadioLabel_fieldText__P5Woe"};